import { Box as ChakraBox } from '@chakra-ui/react';
import { ElementType } from 'react';
import { PolymorphicComponentProps, SystemProps } from './primitives.types';

export type BoxProps<T extends ElementType = 'div'> = PolymorphicComponentProps<T, SystemProps>;

export function Box<T extends ElementType = 'div'>(props: BoxProps<T>) {
  return <ChakraBox {...props} />;
}